import { render, staticRenderFns } from "./AnaesthesiaNotes.vue?vue&type=template&id=007041b2&"
import script from "./AnaesthesiaNotes.vue?vue&type=script&lang=js&"
export * from "./AnaesthesiaNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports